import React from 'react';
import { Link } from '@reach/router';
import { Card, CardCol, CardRow, C } from '@kineticdata/bundle-common';
import { I18n } from '@kineticdata/react';

export const PortfolioCardSmall = ({
  portfolio,
  path,
  components,
  ...props
}) => (
  <Card {...props} to={path} components={{ Link, ...(components || {}) }}>
    <CardRow>
      <CardCol type={['prepend', 'icon']} className="my-2">
        <span
          className={`${portfolio.values['Icon'] ||
            C.ICON_PORTFOLIO} fa-md text-muted`}
        />
      </CardCol>
      <CardCol>
        <CardRow type="subtitle" className="font-weight-normal">
          {portfolio.values['Name']}
        </CardRow>
      </CardCol>
    </CardRow>
  </Card>
);

export const PortfolioCard = ({ portfolio, path, components, ...props }) => (
  <Card {...props} to={path} components={{ Link, ...(components || {}) }}>
    <CardRow>
      <CardCol type={['prepend', 'icon']} className="my-2">
        <span
          className={`${portfolio.values['Icon'] ||
            C.ICON_PORTFOLIO} fa-md text-muted`}
        />
      </CardCol>
      <CardCol>
        <CardRow className="text-muted">
          <small>
            <I18n>PORTFOLIO</I18n>
          </small>
        </CardRow>
        <CardRow type="title" className="">
          {portfolio.values['Name']}
        </CardRow>
        <CardRow className="text-muted">
          {portfolio.values['Short Description']}
        </CardRow>
      </CardCol>
    </CardRow>
  </Card>
);
